export default "__VITE_ASSET__HY0Yya3W__"